import React from "react";
//#region redux
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { DateConstants } from "utils/constants";
import { MonthSelectorProps } from "models/propTypes/timeReportingPropTypes";
//#endregion
//#region components
import { ExtendedEntityPagination } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const MonthSelector: React.FC<MonthSelectorProps> = (props) => {
  const { onMonthToggle, currentMonthDateRange } = props;

  const onNextMonthClick = () => {
    const newLoadingDate = currentMonthDateRange?.end && DateHelper.getFirstDayOfNextMonth(currentMonthDateRange.end);
    newLoadingDate && onMonthToggle(newLoadingDate);
  };

  const onPreviousMonthClick = () => {
    const newLoadingDate =
      currentMonthDateRange?.end && DateHelper.getFirstDayOfPreviousMonth(currentMonthDateRange.end);
    newLoadingDate && onMonthToggle(newLoadingDate);
  };

  return (
    <ExtendedEntityPagination
      textNext={TranslationKeys.TimeReporting.NextMonth}
      textPrevious={TranslationKeys.TimeReporting.PreviousMonth}
      onNavigationNext={onNextMonthClick}
      onNavigationPrevious={onPreviousMonthClick}
    >
      <Grid container direction="column" className={cssExports.entityTitleContainer} alignItems="center">
        <Grid item className={cssExports.statusLabelContainer}>
          <div className={cssExports.statusLabel}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.ThisMonth)}
          </div>
        </Grid>

        <Grid item>
          {props.currentMonthDateRange?.start &&
            LocalizationHelperInstance.getFormattedDate(
              props.currentMonthDateRange?.start,
              DateConstants.MonthLongConfig
            )}
        </Grid>
      </Grid>
    </ExtendedEntityPagination>
  );
};

export default MonthSelector;
